import React from 'react'

import styles from './slider.module.scss'

const minFontSize = 10
const maxFontSize = 40

interface FontSizeSliderProps {
  fontSize?: number
  selectFontSize: (size: number) => void
}

const FontSizeSlider: React.FC<FontSizeSliderProps> = props => {
  const { fontSize, selectFontSize } = props
  return (
    <div className={styles.scaleContainer}>
      <section className={styles.scale}>
        <span
          className={`${styles.decrement} fs-ignore-rage-clicks`}
          onClick={() =>
            selectFontSize(Math.max((fontSize || 25) - 1, minFontSize))
          }
        >
          -
        </span>
        <input
          className={styles.openDrawer}
          name="scale"
          type="range"
          onChange={event =>
            selectFontSize(Math.round(parseFloat(event.target.value)))
          }
          min={minFontSize}
          max={maxFontSize}
          step="1"
          value={fontSize || 25}
        />
        <span
          className={`${styles.increment} fs-ignore-rage-clicks`}
          onClick={() =>
            selectFontSize(Math.min((fontSize || 25) + 1, maxFontSize))
          }
        >
          +
        </span>
      </section>
      <h5>Font Size: {fontSize ? fontSize + 'pt' : '-'}</h5>
    </div>
  )
}

export default FontSizeSlider
